import { render } from "./ADFileUpload.vue?vue&type=template&id=ff5cd572"
import script from "./ADFileUpload.vue?vue&type=script&lang=js"
export * from "./ADFileUpload.vue?vue&type=script&lang=js"

import "./ADFileUpload.vue?vue&type=style&index=0&id=ff5cd572&lang=css"
script.render = render

export default script